<template>
    <div class="photo" :style="photoStyle">
        <img v-gallery="'chat-' + chatId" :src="url">
    </div>
</template>

<script>
    export default {
        name: "ChatPhoto",
        props: {
            chatId: {
                require: true,
            },
            photo: {
                require: true,
                type: Object,
            }
        },
        computed: {
            url() {
                if (!this.photo.url) {
                    return URL.createObjectURL(this.photo.file);
                }
                return this.photo.url;
            },
            photoStyle() {
                return {
                    'background-image': `url(${this.url})`
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .photo {
        padding: 5px;
        border-radius: 15px;
        background-position: 50% 50%;
        background-size: cover;
        background-repeat: no-repeat;
        height: 300px;
        width: 250px;

        img {
            height: 100%;
            width: 100%;
            opacity: 0;
            filter: alpha(opacity=0);
        }
    }
</style>